
import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
import SnackbarStore from '@/store/modules/snackbar';
import { Watch } from 'vue-property-decorator';

const snackModule = getModule(SnackbarStore, store);
@Component({
  computed: {
    snack: {
      get() {
        return snackModule.msg;
      },
    },
  },
})
export default class Snackbar extends Vue {
  show = false;
  msg = '';

  @Watch('this.$store.snackbar.msg')
  setSnack() {
    this.show = snackModule.msg != '';
    this.msg = snackModule.msg;
  }
}
